<template>
  <div :class="dark ? 'black' : 'white'">
    <v-row class="pa-0 ma-0 d-flex align-center">
      <v-col
        class="flex-grow-1 pl-4 pt-1 pb-1"
        style="line-height: 1"
      >
        <template v-for="(r, i) in filterText">
          <span
            :key="i+'_title'"
            class="text-body-2 text--secondary mt-0 mb-0 pt-0 pb-0"
          >{{ r.title }}</span>
          <span
            :key="i+'_val'"
            class="text-body-2 pl-1 mr-1 font-weight-medium text--secondary"
          >{{ r.val }} </span>
        </template>
      </v-col>
      <v-col
        class="mr-2 pa-0 ma-0 align-center"
        style="min-width:36px"
        cols="1"
      >
        <v-btn
          icon
          @click="resetFilter"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang='ts'>

import Vue, { PropType } from 'vue';
import { ReservationStatus } from '@/model/Reservation';

export default Vue.extend({
  name: 'GuestFilterCompactBar',
  components: { },
  props: { },
  data() {
    return { };
  },
  computed: {
    dark(): boolean {
      return this.$vuetify.theme.dark;
    },
    filterText(): Record<string, String>[] {
      const ret = [];

      if (this.$tstore.state.filter.from !== '06:00') {
        ret.push({
          title: `${this.$i18n.tc('label.filter_time_from')}:`,
          val: this.$tstore.state.filter.from,
        });
      }

      if (this.$tstore.state.filter.to !== '24:00') {
        ret.push({
          title: `${this.$i18n.tc('label.filter_time_until')}:`,
          val: this.$tstore.state.filter.to,
        });
      }

      if (this.$tstore.state.filter.tab !== null) {
        ret.push({
          title: `${this.$i18n.tc('label.section')}:`,
          val: this.$tstore.state.filter.tab.name.replace(/ /g, '\u00a0'),
        });
      }

      if (this.$tstore.state.filter.status !== ReservationStatus.Valid) {
        ret.push({
          title: `${this.$i18n.tc('label.status')}:`,
          val: this.$i18n.tc(`code.status.${this.$tstore.state.filter.status}`),
        });
      }

      return ret;
    },
  },
  methods: {
    resetFilter() {
      this.$tstore.dispatch('resetFilter');
    },
  },
});

</script>
